import React, { useEffect } from "react";
import "./CustomTemplate.css";
import CustomTemplateSection from "./components/CustomTemplateSection";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import { GoArrowLeft } from "react-icons/go";
import { useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import customTemplate from "../../../../../Model/AddCustomTemplate/AddCustomTemplate";
import CustomButton from "../../../../controls/CustomButton";
import SettingsSidebar from "../../../../SettingsSidebar/SettingsSidebar";
import CustomLoader from "../../../../controls/CustomLoader";
import { showError } from "../../../../ToastedMessage/ToastedMessage";
import useTitanApp from "../../../../../hooks/useTitanApp";
import AsyncRendererRouter from "../../../../AsyncRendererRouter/AsyncRendererRouter";
import useTitanTemplate from "../../../../../hooks/useTitanTemplate";
import {
  setAiTemplate,
  updateAiTemplates,
  deleteAiTemplateById,
  setSelectedTemplate,
} from "../../../../../dispatchers/templateDispatchers";
import ConsultationAddNewLoadingComponent from "../../../../SettingsLoadingComponents/ConsultationAddNewLoadingComponent";
import CustomAiTemplateSection from "./components/CustomAiTemplateSection";
import { Textarea } from "@mui/joy";
import { v4 as uuidv4 } from "uuid";
import {
  addConsultationTemplate,
  setCurrentShowEditAiTemplateModal,
} from "../../../../../dispatchers/patientDispatchers";
import { getAiTemplateByCompanyId } from "../../../../../dispatchers/templateDispatchers";
function UpdateAiCustomTemplate({ Consultationtemplate }) {
  const { patientState } = useTitanApp();
  const { consultationId } = patientState || {};
  const { templateState } = useTitanTemplate();
  const {
    isConsultationLoading,
    aiTemplate,
    isAiTemplateLoading,
    isAiTemplateDeleteByIdLoading,
    selectedTemplate,
  } = templateState || {};
  const navigate = useNavigate();
  const [customTemplates, setCustomTemplates] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [consultationSummary, setConsultationSummary] = useState("");
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const { appState } = useTitanApp();
  const { companyId, darkMode } = appState || {};
  const location = useLocation();
  const passedTemplate = location.state?.template || Consultationtemplate;
  const cameFromModal = !!Consultationtemplate;

  const AddTemplateSection = async (isDuplcate, Dupsection) => {
    const newSection = new customTemplate(isDuplcate, Dupsection).obj;

    setCustomTemplates((prevSections) => [...prevSections, newSection]);
    //add in nms
  };
  function handleUpdateSection(updatedSection) {
    const updatedData = customTemplates?.map((item) => {
      if (item.groupId === updatedSection.groupId) {
        return updatedSection;
      }
      return item;
    });
    setCustomTemplates(updatedData);
  }
  useEffect(() => {
    if (passedTemplate?._id === selectedTemplate._id) {
      setIsTemplateSelected(true);
    }
  }, [aiTemplate]);

  const handleSave = () => {
    if (!consultationSummary.trim()) {
      showError("Consultation Summary cannot be empty.", true, false);
      return;
    }

    const transformed = {
      _id: passedTemplate?._id,
      templateName: templateName,
      companyID: companyId,
      consultationSummary: consultationSummary,
      templateSections: customTemplates?.map((section) => ({
        groupId: section?.groupId,
        sectionTitle: section?.sectionTitle,
        userControls: section?.userControls.map((control) => ({
          label: control?.label,
          required: control?.required ?? true,
          value: control?.value ?? null,
          userControlId:
            control?.userControlId || `${section?.groupId}-${Math.random()}`,
        })),
      })),
    };

    const updateData = updateAiTemplates(transformed);
    if (updateData) {
      if (!cameFromModal) {
        setAiTemplate([]);
        navigate("/settings/templates/aiconsultation");
      } else {
        setAiTemplate([]);
        getAiTemplateByCompanyId(companyId);
        setCurrentShowEditAiTemplateModal(false);
      }
    } else {
      showError("Consultation could not be updated.", true, false);
    }
  };

  const handleDeleteTemplate = async () => {
    const deletedData = await deleteAiTemplateById(passedTemplate?._id);
    if (deletedData) {
      if (!cameFromModal) {
        setAiTemplate([]);
        navigate("/settings/templates/aiconsultation");
      } else {
        setAiTemplate([]);
        var allTemplates = await getAiTemplateByCompanyId(companyId);
        setCurrentShowEditAiTemplateModal(false);
      }
    } else {
      showError("AI Template could not be deleted.", true, false);
    }
  };

  useEffect(() => {
    const templateData = passedTemplate;
    if (templateData) {
      const mappedSections = templateData?.templateSections?.map(
        (section, sectionIndex) => ({
          ...section,
          groupId: section?.groupId || uuidv4(),
          userControls: (section?.userControls || []).map(
            (control, controlIndex) => ({
              ...control,
              userControlId:
                control?.userControlId ||
                `${section.groupId || `group-${sectionIndex}`}-${controlIndex}`,
            })
          ),
        })
      );

      setTemplateName(templateData?.templateName || "");
      setCustomTemplates(mappedSections);
      setConsultationSummary(templateData?.consultationSummary || "");
    }
  }, [passedTemplate]);

  function handleDeleteSection(objectToDelete) {
    const updatedSection = customTemplates?.filter(
      (control) => control !== objectToDelete
    );
    setCustomTemplates(updatedSection);
  }

  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = [...customTemplates];
    const [reorderedItem] = items?.splice(result.source.index, 1);
    items?.splice(result?.destination?.index, 0, reorderedItem);
    setCustomTemplates(items);
  };

  const { appData } = useLoaderData() || {};

  return (
    <AsyncRendererRouter
      resolve={appData}
      isLoading={isConsultationLoading}
      loadingElement={<ConsultationAddNewLoadingComponent />}
    >
      <div className="settings_page">
        <div className="settings_wrapper">
          {!cameFromModal && <SettingsSidebar />}
          <div className="settings_content_wrapper">
            {!cameFromModal && (
              <div className="settings_heading">
                <h1>Consultation</h1>
              </div>
            )}

            <div>
              <div>
                {!cameFromModal && (
                  <div
                    className="back_to_SettingsListView"
                    onClick={() => {
                      navigate("/settings/templates/aiconsultation");
                      setAiTemplate([]);
                    }}
                  >
                    <GoArrowLeft className="icons-color" />
                    <p>Back</p>
                  </div>
                )}

                <div className="medicine-card customcard">
                  <div className="temp_content">
                    <div className="ai_temp_body">
                      <div className="ai_temp_body_a">
                        <div className="template_control ai_sec_name">
                          <TextField
                            className="text_input_field"
                            required
                            id="outlined-required"
                            value={templateName}
                            label="Name"
                            placeholder="eg: generate the consultation template for ear wax"
                            onChange={(e) => setTemplateName(e?.target?.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <>
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable
                      droppableId="customTemplateSections"
                      type="section"
                      direction="vertical"
                    >
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          {...provided.dragHandleProps}
                          className={`drag_card ${
                            snapshot.isDragging ? "dragging-template" : ""
                          }`}
                        >
                          {customTemplates?.map((temp, index) => (
                            <Draggable
                              key={temp.groupId}
                              draggableId={temp.groupId}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <CustomAiTemplateSection
                                    AddTemplateSection={AddTemplateSection}
                                    handleDeleteSection={handleDeleteSection}
                                    template={temp}
                                    handleUpdateSection={handleUpdateSection}
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                  {passedTemplate?.consultationSummary && (
                    <div className="medicine-card customcard">
                      <div className="temp_head_summary">
                        <h4>Consultation Summary</h4>
                      </div>
                      <div className="consultation-summary">
                        <TextField
                          value={consultationSummary}
                          onChange={(e) =>
                            setConsultationSummary(e.target.value)
                          }
                          className="textarea_summary_input"
                          rows={30}
                          multiline
                        />
                      </div>
                    </div>
                  )}
                </>
                <div className="footer_btn">
                  <CustomButton
                    label={
                      isAiTemplateDeleteByIdLoading
                        ? "Deleting..."
                        : "Delete Template"
                    }
                    isdisable={
                      isTemplateSelected === true
                        ? isTemplateSelected
                        : isAiTemplateDeleteByIdLoading
                    }
                    action={handleDeleteTemplate}
                  />
                  <CustomButton
                    isdisable={!consultationSummary.trim()}
                    label="Save Changes"
                    action={handleSave}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AsyncRendererRouter>
  );
}

export default UpdateAiCustomTemplate;
